module.exports = __webpack_public_path__ + "img/logo_leybold_main.3d078910.png";